import { BriefcaseBusiness, MapPinIcon } from "lucide-react";
import { useContext } from "react";
import { CreateProfileContext } from "@pages/CreateProfile/CreateProfileLayout";

const LivePreview = () => {
  const { previewData } = useContext(CreateProfileContext)!;
  const { firstName, lastName, profilePic, jobTitle, location, industryType } = previewData;

  console.log('previewData',previewData)

  return (
    <div className="rounded-2xl bg-white flex flex-col flex-1 shrink-0 gap-4 px-5 pt-5 pb-10 h-max min-h-96">
      <div className="flex justify-between items-center h-max w-full">
        <div className="flex flex-col gap-1">
          <span className="font-bold text-primary">Live profile preview</span>
          <span className="text-sm text-light-black">
            Basic preview using details from steps 1, 2 and 3.
          </span>
        </div>
        <div className="flex items-center justify-center rounded-full bg-blue-50 text-blue-600 h-max font-semibold text-xss px-2 py-0.5">
          Basic Profile
        </div>
      </div>

      <div className="rounded-md border p-4">
        <div className="flex gap-6">
          <div className="h-28 w-28 rounded-full border flex items-center justify-center bg-[#E2E8F0] border-[#95A9C4] overflow-hidden">
            {profilePic ? (
              <img src={profilePic} className="h-full w-full object-cover" />
            ) : (
              <span className="font-bold text-4xl text-primary">
                {firstName?.charAt(0)}{lastName?.charAt(0)}
              </span>
            )}
          </div>
          <div className="flex flex-col">
            <span className="font-bold uppercase text-2xl text-primary">
              {firstName || lastName ? `${firstName ?? ""} ${lastName ?? ""}`.trim() : "Your name"}
            </span>
            <span className="text-sm font-medium text-primary mt-1">
              {jobTitle || "Your job title"}
            </span>
            <div className="flex items-center gap-8 mt-4">
              {industryType?.length ? 
                <div className="flex items-center gap-1">
                  <BriefcaseBusiness size={12} color="gray" />
                  <span className="text-xss font-medium text-primary">{industryType}</span>
                </div>
                :
                null
              }
              {
                location?.length ?
                  <div className="flex items-center gap-1">
                    <MapPinIcon size={12} color="gray" />
                    <span className="text-xss font-medium text-primary">
                      {location || "Your location"}
                    </span>
                  </div>
                  :
                  null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivePreview;
